import { createContext, useContext } from 'react';
import type { QueueActions } from './useQueueActions';

/**
 * How a card reaches the one queue flow the app mounts.
 *
 * Its own module for `playback/context.ts`'s reason: the provider is a component
 * (`QueueActionsHost.tsx`) and the consumer is a hook every grid calls, and keeping the two in one
 * file makes that file export both a component and a function — which costs Fast Refresh, so an edit
 * to a card would reload the app instead of the component.
 */
export const QueueFlowContext = createContext<QueueActions | null>(null);

/**
 * The flow, from any card. `null` outside the host — which is /embed, the one screen rendered without
 * the shell: an embedded player is one video inside somebody else's page and has no business growing
 * a queue in it.
 */
export function useQueueFlow(): QueueActions | null {
  return useContext(QueueFlowContext);
}
